import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { DashboardTotalCards } from "./DashboardTotalCards";

const Dashboard = ({permitRole}) => {
    const {t} = useTranslation();
    const {setPageTitle} = useOutletContext();
    useEffect(() => { 
        setPageTitle(t("Dashboard")) 
    }, [setPageTitle]);
    return (
        <>
            <DashboardTotalCards />
        </>
    )
}
export default Dashboard;